// //api version
// export const generateFakeRooms = () => {
//   let fakeRooms = []
//   for(let i=0; i<30; i++) {
//     let participants = []
//     let usersNo = Math.random()*20;
//     for(let p=0; p < usersNo; p++) {
//       let participant = {
//         id: `${p}`,
//         user_id: `${p}`,
//         user_name: `User ${p+1}`
//       }
//       participants.push(participant)
//     }
//     let newRoom = {
//       name: `Room ${i+1}`,
//       id: `${i}`,
//       type: "meeting",
//       participants: participants,
//       link: ""
//     }
//     fakeRooms.push(newRoom)
//   }
//   return fakeRooms
// }

//database version
export const generateFakeRooms = () => {
  let fakeRooms = [];
  for (let i = 0; i < 10; i++) {
    let participants = [];
    let usersNo = i;
    for (let p = 0; p < usersNo * 2; p++) {
      let participant = {
        id: `${p}`,
        registered: true,
        zoom_user_name: `User ${p + 1}`
      };
      participants.push(participant);
    }
    let type = 'private';
    let colour = '#CBCBCB';
    if (i < 3) {
      type = 'shared';
      colour = '#5A6A7D';
    } else if (i == 7) {
      type = 'in';
      colour = '#ffffff';
    } else if (i == 9) {
      type = 'hub';
      colour = '#000000';
    }
    let newRoom = {
      active: true,
      topic: `Room ${i + 1}`,
      id: `${i}`,
      colour: colour,
      type: type,
      participants: participants,
      host: '',
      display: true
    };
    fakeRooms.push(newRoom);
  }
  return fakeRooms;
};

export const roomTextColorOptions = [
  {
    value: 'white',
    label: 'White'
  },
  {
    value: 'black',
    label: 'Black'
  }
];
